import React from 'react';
import PropTypes from 'prop-types';
import { Button, Spin, Empty, Table } from 'antd';
import CreativeFormModal from '../../../containers/CreativeFormModal';

const CreativeTab = ({ columns, loading, creativeList, showCreativeModal }) => (
  <div>
    <Spin spinning={loading}>
      {!loading && !creativeList.length && (
        <Empty description="No Creatives">
          <Button type="primary" onClick={showCreativeModal}>
            Create Now
          </Button>
        </Empty>
      )}

      {creativeList.length ? (
        <div className="p20">
          <Button type="primary" style={{ marginBottom: 10 }} onClick={showCreativeModal}>
            Build New Creative
          </Button>

          <Table dataSource={creativeList} columns={columns} />
        </div>
      ) : null}
    </Spin>
    <CreativeFormModal />
  </div>
);

CreativeTab.defaultProps = {
  submitting: false,
};

CreativeTab.propTypes = {
  submitting: PropTypes.bool,
  handleSubmit: PropTypes.func.isRequired,
  removeCreative: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
  showCreativeModal: PropTypes.func.isRequired,
};

export default CreativeTab;
